import React from 'react';

import { getAssetFilePath } from '../../products/summary/common/get_asset_file_path';

const sergeiShockedImgPath = '/assets/brand/ctm/images/sergei_half_shocked.png';
const sergeiShockedBackgroundImgPath = '/assets/brand/ctm/images/background-horizontal.svg';

const PreloadImage = () => {
    return (
        <>
            <link rel="preload" href={getAssetFilePath(sergeiShockedImgPath)} as="image" />
            <link rel="preload" href={getAssetFilePath(sergeiShockedBackgroundImgPath)} as="image" />
        </>
    );
};

export { PreloadImage, sergeiShockedImgPath, sergeiShockedBackgroundImgPath };
